import contract from '@mailobj-browser/front/js/contracts/contract.js'
import meet from './meet/meet.js'
import thread from './thread/thread.js'

export default contract({
  meet,
  thread
})